import React from "react";
import {GamesListBaseModel} from "../games-list-base.model";
import {GamesGridComponent} from "../../../../../components/games-grid/games-grid.component";
import {ArenaGamesGridConfiguration} from "../../../../configurations/config-data-sections/arenas.configuration";
import {IArenaToGamesListAdapter} from "../../arenas/arena-to-games-list-adapter.interface";
import {TextTranslation} from "../../../../translation/text-translation";
import {GameListTitleComponent} from "../../../../../components/game-list-title/game-list-title.component";
import {ListTitleTextBox} from "../../../../../components/game-list-title/boxes/list-title-text/list-title-text.box";

export class GamesGridListModel extends GamesListBaseModel {
    constructor(protected readonly gridConfig: ArenaGamesGridConfiguration,
                arena: IArenaToGamesListAdapter) {
        super(arena)
    }

    protected _getGameTypes(): number[] {
        const gameTypes = this.gridConfig.gamesId || [];

        return this.services.abFiltering.filterGamesByAbTesting(this.gridConfig.gamesAdminRefKey, gameTypes);

    }

    protected get _isAISorted(): boolean {
        return this.gridConfig.useAISortedList;
    }


    protected _shouldBeDisplayed(): boolean {
        return true;
        //return this.gridConfig.display;
    }

    protected get _numberOfGamesToBeIgnoredInAISorting(): number | undefined {
        return undefined;
    }

    get listId(): number {
        return this.gridConfig.listId;
    }

    get title(): TextTranslation {
        return this.services.translation.getTranslation(this.gridConfig.title);
    }

    get maxGamesToShowInList(): number {
        return this._getGameTypes().length; // for grids we show all games
    }

    get forceInLayout(): boolean {
        return true;
    }

    get templateType(): string {
        return this.gridConfig.templateType;
    }

    renderListHeader(): React.ReactElement {
        const title = (
            <ListTitleTextBox className="cy-games-title-text">
                {this.title.translation}
            </ListTitleTextBox>
        );

        return (
            <GameListTitleComponent title={title}/>
        );
    }

    protected _renderList(listPosition: number): React.ReactElement | null {
        return (
            <GamesGridComponent key={this.listKey}
                                viewModel={this}
                                skipIntermediatePage={false}
                                disableGameInfoHover={false}
                                useSquareIcons={this.gridConfig.useSquareIcons} />
        );
    }


}